module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap unfixed"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.selectHeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-height"
  }, [_vm._v("您的身高")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultHeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultHeight) + "CM")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectWeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-weight"
  }, [_vm._v("您的体重")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultWeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultWeight) + "kg")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectMotion()
      }
    }
  }, [_c('div', {
    staticClass: "icon-motion"
  }, [_vm._v("活动强度")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v(_vm._s(_vm.defaultMotion))])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算能量")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc19a7be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dayneed/fillform.vue
// module id = 153
// module chunks = 1